import { render } from "./BlockUserConfirm.vue?vue&type=template&id=8a346f36"
import script from "./BlockUserConfirm.vue?vue&type=script&lang=js"
export * from "./BlockUserConfirm.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__